export default __webpack_public_path__ + "static/media/Iconly-Bold-Wallet.5d555504.svg";